import React from 'react';
import { useHistory } from 'react-router-dom';
import Result from '../Result/Result.component';
import { Button } from '../Button/Button.styled';
import PageTitle from '../PageTitle/PageTitle.component';

function NotFound() {
  const history = useHistory();

  const voltarParaHome = () => {
    history.push('/');
  };

  const tituloPagina = 'Página não Encontrada';

  return (
    <>
      <PageTitle titulo={tituloPagina} />
      <Result
        status="warning"
        subTitle="A página solicitada não existe ou foi movida."
        extra={
          <Button type="primary" onClick={voltarParaHome}>
            Voltar para Home
          </Button>
        }
      />
    </>
  );
}

export default NotFound;
